import { useRef, useState } from 'react';
import useAnalyticEvent from '../../shared/hooks/useAnalyticEvent';
import { EventActions } from '../../analytics/uiMetrics';
import getAssetUrl from '../../utilities/getAssetUrl';
import { Container, VideoContainer } from './HowItWorks.styles';

const HowItWorks = () => {
  const [playEventSent, setPlayEventSent] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const { recordGenericEvent } = useAnalyticEvent();

  const handleVideoStart = () => {
    if (playEventSent) return;
    setPlayEventSent(true);
    recordGenericEvent('HowItWorks', 'VideoPlayer - Play', EventActions.Clicked);
  };

  const handleVideoEnd = () => {
    recordGenericEvent('HowItWorks', 'VideoPlayer - Ended', EventActions.Changed);
  };

  return (
    <Container>
      <VideoContainer>
        <video
          controls
          crossOrigin="anonymous"
          onEnded={handleVideoEnd}
          onPlay={handleVideoStart}
          poster={getAssetUrl('/images/how-it-works.webp')}
          preload="metadata"
          ref={videoRef}
          width="100%"
        >
          <source
            src={`${process.env.CARVANA_APP_CDN_URL}/stc-assets/STC_HowTo.mp4`}
            type="video/mp4"
          />
          <track
            kind="captions"
            src={getAssetUrl('/captions/STC_HowTo.vtt')}
            label="English"
            srcLang="en"
            default
          />
          Your browser does not support HTML video.
        </video>
      </VideoContainer>
    </Container>
  );
};

export default HowItWorks;
